import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import LoadingPopup from "./loading";
import { secretKey } from "./data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeadDetail from "./leadDetail";
import SendClientsConf from "./sendClientsConf";
import SendLeadsDetails from "./sendLeadsDetails";
import ImportLeadSend from "./importLeadsSend";
import SendClientsResults from "./sendClientsResults";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const SendLeads = (props) => {
  const [loading, setLoading] = useState(true);
  const [sendOption, setSendOption] = useState("PENDING");
  const [sendType, setSendType] = useState("CHF");
  const [leads, setLeads] = useState([]);
  const [clients, setClients] = useState([]);
  const [leadDetail, setLeadDetail] = useState([]);
  const [showLeadDetail, setShowLeadDetail] = useState(false);
  const [chooseLeads, setChooseLeads] = useState([]);
  const [chooseLeadsFlag, setChooseLeadsFlag] = useState(false);
  const [showSendLeadsDetails, setShowSendLeadsDetails] = useState(false);
  const [showImportLeads, setShowImportLeads] = useState(false);
  const [from, setFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [to, setTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [company, setCompany] = useState("");

  const showLeadDetailBox = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setLeadDetail(leads.filter((lead) => +lead.id === +value)[0]);
    setShowLeadDetail(true);
  };

  const fetchLeadsTemp = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadsSendTemp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchLeadsSend = async () => {
    var body = { from: from, to: to, type: sendType, company: company };

    await fetch("https://apisellcrm.ftpeople.pl/getLeadsSendSend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchClients = async (option) => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getSendClientsConf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        try {
          if (option ? option === "PENDING" : sendOption === "PENDING") {
            setClients(data.filter((el) => +el.active === 1));
          } else {
            setClients(data);
          }
          if (company === "") {
            setCompany(
              data
                .filter((el) => +el.active === 1)
                .filter((el) => el.company === sendType)[0]
                ? data
                    .filter((el) => +el.active === 1)
                    .filter((el) => el.company === sendType)[0].id
                : ""
            );
          }
          if (option ? option === "PENDING" : sendOption === "PENDING") {
            fetchLeadsTemp();
          } else {
            fetchLeadsSend();
          }
        } catch (err) {
          console.log(err);
        }
      })
      .catch((error) => {});
  };

  const getData = (option) => {
    setLeads([]);
    fetchClients(option);
  };

  useEffect(() => {
    getData();
  }, []);

  const leadsBody = (
    <>
      <div
        style={{
          textAlign: "left",
          marginBottom: "2vh",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <select
          style={{ border: "1px solid gray" }}
          onChange={(e) => {
            setSendType(e.target.value);
            setChooseLeads([]);
            setChooseLeadsFlag(false);
          }}
        >
          <option key={0} value={"CHF"}>
            CHF
          </option>
          <option key={1} value={"SKD"}>
            SKD
          </option>
          <option key={2} value={"WIBOR"}>
            WIBOR
          </option>
        </select>
        <span
          style={{
            textTransform: "lowercase",
            fontSize: ".8vw",
          }}
        >
          Ilość: {leads.filter((el) => el.company === sendType).length}
        </span>
        <button
          className="loginButtonLogin"
          value="yes"
          style={{
            margin: "0",
            backgroundColor: "green",
            borderColor: "green",
            width: "10vw",
            padding: "auto",
            height: "3vh",
            fontSize: ".6vw",
          }}
          onClick={async (e) => {
            setShowImportLeads(true);
          }}
        >
          importuj
        </button>
        <button
          className="loginButtonLogin"
          value="yes"
          style={{
            margin: "0",
            backgroundColor: "yellow",
            borderColor: "yellow",
            color: "black",
            width: "10vw",
            padding: "auto",
            height: "3vh",
            fontSize: ".6vw",
          }}
          onClick={async (e) => {
            var arr = [];
            leads
              .filter((el) => el.company === sendType)
              .map((ep) => {
                arr.push(ep.id);
              });
            setChooseLeads(arr);
            setChooseLeadsFlag(true);
          }}
        >
          zaznacz wszystkie
        </button>
        <button
          className="loginButtonLogin"
          value="yes"
          style={{
            margin: "0",
            backgroundColor: "yellow",
            borderColor: "yellow",
            color: "black",
            width: "10vw",
            padding: "auto",
            height: "3vh",
            fontSize: ".6vw",
          }}
          onClick={async (e) => {
            setChooseLeads([]);
            setChooseLeadsFlag(false);
            getData();
          }}
        >
          odznacz wszystkie
        </button>
      </div>
      {leads
        .filter((el) => el.company === sendType)
        .map((lead) => (
          <>
            {chooseLeadsFlag ? (
              <div
                className="progressBox"
                style={{
                  width: "5vw",
                  height: "5vh",
                  borderBottomLeftRadius: "5px",
                  borderTopLeftRadius: "5px",
                  padding: "5px",
                  backgroundColor: "orange",
                  color: "white",
                  position: "fixed",
                  right: "0",
                  top: "25vh",
                  zIndex: "2",
                  bottom: "0",
                  textAlign: "center",
                  cursor: "pointer",
                  textTransform: "uppercase",
                  lineHeight: "2vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  setShowSendLeadsDetails(true);
                }}
              >
                <span
                  style={{
                    fontSize: "1vw",
                    fontWeight: "600",
                    animation: "pulse 1s infinite",
                  }}
                >
                  WYŚLIJ LEADY
                </span>
              </div>
            ) : (
              ""
            )}
            {showSendLeadsDetails ? (
              <SendLeadsDetails
                close={() => {
                  setShowSendLeadsDetails(false);
                  getData();
                }}
                sendOption={sendType}
                leads={leads.filter(
                  (el) =>
                    el.company === sendType &&
                    chooseLeads.filter((x) => +x === +el.id).length > 0
                )}
                clients={clients.filter((el) => el.company === sendType)}
              />
            ) : (
              ""
            )}
            {showLeadDetail ? (
              <>
                <LeadDetail
                  close={() => {
                    setShowLeadDetail(false);
                    setLeadDetail([]);
                  }}
                  lead={leadDetail}
                  user={props.user}
                />
              </>
            ) : (
              <div
                style={{
                  width: "100%",
                  marginBottom: "1vh",
                  border: "2px solid lightgray",
                  borderRadius: "5px",
                  minHeight: "5vh",
                  display: "flex",
                  alignItems: "start",
                  flexWrap: "wrap",
                  padding: "5px",
                  fontSize: "1vw",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    width: "2%",
                    textAlign: "left",
                    padding: ".5%",
                    paddingRight: "5px",
                  }}
                >
                  <input
                    style={{ width: "15px", height: "15px", margin: "0" }}
                    className="checkInput"
                    type="checkbox"
                    value={lead.id}
                    checked={
                      chooseLeads.filter((q) => +q === +lead.id).length > 0
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      try {
                        var arr = [];

                        if (
                          chooseLeads.filter((q) => +q === +e.target.value)
                            .length > 0
                        ) {
                          chooseLeads.map((p) => {
                            if (+p !== +e.target.value) {
                              arr.push(p);
                            }
                          });
                        } else {
                          chooseLeads.map((p) => {
                            arr.push(p);
                          });
                          arr.push(e.target.value);
                        }
                        if (arr.length > 0) {
                          setChooseLeadsFlag(true);
                        } else {
                          setChooseLeadsFlag(false);
                        }
                        setChooseLeads(arr);
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "8%",
                    textAlign: "left",
                    padding: ".5%",
                    paddingRight: "5px",
                  }}
                >
                  <p
                    style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}
                  >
                    Nazwa:
                  </p>
                  <div
                    style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                  >
                    <span style={{ width: "100%", minHeight: ".8vw" }}>
                      {lead.name.substring(0, 30)}
                    </span>
                    <button
                      className="loginButtonLogin"
                      id={"name"}
                      value={lead.id}
                      style={{
                        margin: "0",
                        backgroundColor: "transparent",
                        color: "green",
                        border: "none",
                        width: "1%",
                        fontSize: ".6vw",
                        padding: "5px 5px",
                      }}
                      onClick={showLeadDetailBox}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </div>
                </div>
                <div style={{ width: "8%", textAlign: "left", padding: ".5%" }}>
                  <p
                    style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}
                  >
                    Numer telefonu:
                  </p>{" "}
                  <div
                    style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                  >
                    <span style={{ width: "100%", minHeight: ".8vw" }}>
                      {lead.phone}
                    </span>
                  </div>
                </div>
                <div
                  style={{ width: "14%", textAlign: "left", padding: ".5%" }}
                >
                  <p
                    style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}
                  >
                    Adres e-mail:
                  </p>
                  <div
                    style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                  >
                    <span
                      style={{
                        width: "100%",
                        minHeight: ".8vw",
                        lineBreak: "anywhere",
                      }}
                    >
                      {lead.mail}
                    </span>
                  </div>
                </div>
                <div
                  style={{ width: "35%", textAlign: "left", padding: ".5%" }}
                >
                  <p
                    style={{ fontWeight: "600", margin: "0", fontSize: ".7vw" }}
                  >
                    Notatka:
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexWrap: "wrap",
                      justifyContent: "left",
                    }}
                  >
                    <span
                      style={{
                        lineBreak: "anywhere",
                        fontSize: "1vw",
                        width: "100%",
                        minHeight: ".8vw",
                      }}
                    >
                      {lead.statusNote}
                    </span>
                  </div>
                </div>
                <div
                  style={{ width: "10%", textAlign: "left", padding: ".5%" }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      margin: "0",
                      fontSize: ".7vw",
                    }}
                  >
                    Źródło:
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexWrap: "wrap",
                      justifyContent: "left",
                    }}
                  >
                    <span
                      style={{
                        lineBreak: "anywhere",
                        width: "100%",
                      }}
                    >
                      {lead.source}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    width: "7%",
                    textAlign: "left",
                    padding: ".5%",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      margin: "0",
                      fontSize: ".7vw",
                    }}
                  >
                    Status:
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexWrap: "wrap",
                      justifyContent: "left",
                    }}
                  >
                    <span
                      style={{
                        lineBreak: "anywhere",
                        width: "100%",
                        fontSize: ".8vw",
                      }}
                    >
                      {lead.status}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    width: "5%",
                    textAlign: "left",
                    padding: ".5%",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "blue",
                      borderColor: "blue",
                      width: "100%",
                      padding: "5px",
                      height: "auto",
                      fontSize: ".6vw",
                    }}
                    onClick={async (e) => {
                      var body = {
                        id: lead.id,
                        source: lead.source,
                      };

                      console.log(body);

                      await fetch(
                        "https://apisellcrm.ftpeople.pl/deleteFromSend",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body),
                        }
                      )
                        .then((response) => response.text())
                        .then((data) => {
                          getData();
                        })
                        .catch((error) => {});
                    }}
                  >
                    usuń
                  </button>
                </div>
              </div>
            )}
          </>
        ))}
    </>
  );

  const getResult = () => {
    if (new Date(to) < new Date(from)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    if (new Date(from) > new Date(to)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    if (from && to) {
      getData();
    }
  };

  const leadsBodySend = (
    <>
      {showLeadDetail ? (
        <>
          <LeadDetail
            close={() => {
              setShowLeadDetail(false);
              setLeadDetail([]);
            }}
            lead={leadDetail}
            user={props.user}
          />
        </>
      ) : (
        <>
          <div
            style={{
              textAlign: "left",
              marginBottom: "2vh",
              display: "flex",
              alignItems: "end",
              gap: "20px",
            }}
          >
            <select
              style={{ border: "1px solid gray" }}
              onChange={(e) => {
                setSendType(e.target.value);
                setLeads([]);
              }}
            >
              <option key={0} value={"CHF"}>
                CHF
              </option>
              <option key={1} value={"SKD"}>
                SKD
              </option>
              <option key={2} value={"WIBOR"}>
                WIBOR
              </option>
            </select>

            <select
              style={{ border: "1px solid gray" }}
              value={company}
              onChange={(e) => {
                setCompany(e.target.value);
                setLeads([]);
              }}
            >
              {clients
                .filter((el) => el.company === sendType)
                .map((c) => (
                  <>
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  </>
                ))}
            </select>

            <div
              style={{
                display: "flex",
                gap: "10px",
                width: "50%",
              }}
              className="inputBox"
            >
              <div style={{ width: "45%" }}>
                <label
                  style={{
                    fontSize: ".6vw",
                    paddingLeft: "5px",
                  }}
                >
                  od
                </label>
                <input
                  style={{
                    height: "3vh",
                    width: "100%",
                    border: "1px solid gray",
                  }}
                  type="date"
                  id="name"
                  name="name"
                  value={from}
                  onChange={(e) => {
                    setLeads([]);
                    setFrom(e.target.value);
                  }}
                />
              </div>
              <div style={{ width: "45%" }}>
                <label
                  style={{
                    fontSize: ".6vw",
                    paddingLeft: "5px",
                  }}
                >
                  do
                </label>
                <input
                  style={{
                    height: "3vh",
                    width: "100%",
                    border: "1px solid gray",
                  }}
                  type="date"
                  id="name"
                  name="name"
                  value={to}
                  onChange={(e) => {
                    setLeads([]);
                    setTo(e.target.value);
                  }}
                />
              </div>
            </div>

            <button
              className="loginButtonLogin"
              value="yes"
              style={{
                margin: "0",
                backgroundColor: "yellow",
                borderColor: "yellow",
                color: "black",
                width: "10vw",
                padding: "auto",
                height: "3vh",
                fontSize: ".6vw",
              }}
              onClick={async (e) => {
                getResult();
              }}
            >
              pokaż
            </button>
          </div>

          <div
            style={{ textAlign: "left", fontSize: ".8vw", marginBottom: "1vh" }}
          >
            Ilość: {leads.length}
          </div>
          {leads
            .filter((el) => el.company === sendType)
            .map((lead) => (
              <>
                <div
                  style={{
                    width: "100%",
                    marginBottom: "1vh",
                    border: "2px solid lightgray",
                    borderRadius: "5px",
                    minHeight: "5vh",
                    display: "flex",
                    alignItems: "start",
                    flexWrap: "wrap",
                    padding: "5px",
                    fontSize: "1vw",
                    gap: "5px",
                  }}
                >
                  <div
                    style={{
                      width: "8%",
                      textAlign: "left",
                      padding: ".5%",
                      paddingRight: "5px",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Nazwa:
                    </p>
                    <div
                      style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                    >
                      <span style={{ width: "100%", minHeight: ".8vw" }}>
                        {lead.name.substring(0, 30)}
                      </span>
                      <button
                        className="loginButtonLogin"
                        id={"name"}
                        value={lead.id}
                        style={{
                          margin: "0",
                          backgroundColor: "transparent",
                          color: "green",
                          border: "none",
                          width: "1%",
                          fontSize: ".6vw",
                          padding: "5px 5px",
                        }}
                        onClick={showLeadDetailBox}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                  </div>
                  <div
                    style={{ width: "8%", textAlign: "left", padding: ".5%" }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Numer telefonu:
                    </p>{" "}
                    <div
                      style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                    >
                      <span style={{ width: "100%", minHeight: ".8vw" }}>
                        {lead.phone}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{ width: "14%", textAlign: "left", padding: ".5%" }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Adres e-mail:
                    </p>
                    <div
                      style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}
                    >
                      <span
                        style={{
                          width: "100%",
                          minHeight: ".8vw",
                          lineBreak: "anywhere",
                        }}
                      >
                        {lead.mail}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{ width: "35%", textAlign: "left", padding: ".5%" }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Notatka:
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        justifyContent: "left",
                      }}
                    >
                      <span
                        style={{
                          lineBreak: "anywhere",
                          fontSize: "1vw",
                          width: "100%",
                          minHeight: ".8vw",
                        }}
                      >
                        {lead.statusNote}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{ width: "10%", textAlign: "left", padding: ".5%" }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Źródło:
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        justifyContent: "left",
                      }}
                    >
                      <span
                        style={{
                          lineBreak: "anywhere",
                          width: "100%",
                        }}
                      >
                        {lead.source}
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "7%",
                      textAlign: "left",
                      padding: ".5%",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        margin: "0",
                        fontSize: ".7vw",
                      }}
                    >
                      Status:
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                        justifyContent: "left",
                      }}
                    >
                      <span
                        style={{
                          lineBreak: "anywhere",
                          width: "100%",
                          fontSize: ".8vw",
                        }}
                      >
                        {lead.status}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ))}
        </>
      )}
    </>
  );

  const createExcelDS = () => {
    var tab = [];
    leads.map((el) => {
      tab.push([
        el.id,
        el.name,
        el.phone,
        el.mail,
        el.status,
        el.source,
        el.sourceNote,
        el.date,
        el.statusNote,
        el.company,
        el.sourceLink,
        clients.filter((eq) => +eq.id === +company)[0].name,
      ]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    var header = [
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Status",
      "Źródło",
      "Notatka - źródło",
      "Data pozyskania",
      "Notatka",
      "Dział",
      "LINK źródło",
      "Firma",
    ];
    downloadExcel({
      fileName: "leads_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  return (
    <div>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          {showImportLeads ? (
            <ImportLeadSend
              close={() => {
                setShowImportLeads(false);
                getData();
              }}
            />
          ) : (
            ""
          )}
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "2vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
              }}
            >
              {sendOption === "PENDING" ||
              sendOption === "CONF" ||
              sendOption === "FINISHED" ? (
                <>
                  {sendOption !== "FINISHED" ? (
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "green",
                        borderColor: "green",
                        width: "180px",
                      }}
                      onClick={getData}
                    >
                      ODŚWIEŻ
                    </button>
                  ) : (
                    ""
                  )}
                  {sendOption === "FINISHED" ? (
                    <>
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        style={{
                          margin: "0",
                          backgroundColor: "green",
                          borderColor: "green",
                          width: "180px",
                        }}
                        onClick={exportToExcel}
                      >
                        EKSPORTUJ
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <div style={{ height: "3.2vh" }}></div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
                marginTop: "3vh",
              }}
            >
              <button
                className="loginButtonLogin"
                style={{
                  margin: "0",
                  backgroundColor: "orange",
                  borderColor: "orange",
                  width: "250px",
                }}
                value={"PENDING"}
                onClick={(e) => {
                  setSendOption(e.target.value);
                  setChooseLeads([]);
                  setChooseLeadsFlag(false);
                  getData(e.target.value);
                }}
              >
                KOLEJKA DO WYSYŁKI
              </button>
              <button
                className="loginButtonLogin"
                style={{
                  margin: "0",
                  backgroundColor: "blue",
                  borderColor: "blue",
                  width: "250px",
                }}
                value={"FINISHED"}
                onClick={(e) => {
                  setSendOption(e.target.value);
                  setChooseLeads([]);
                  setChooseLeadsFlag(false);
                  getData(e.target.value);
                }}
              >
                LEADY WYSŁANE
              </button>
              <button
                className="loginButtonLogin"
                style={{
                  margin: "0",
                  backgroundColor: "cyan",
                  borderColor: "cyan",
                  color: "black",
                  width: "250px",
                }}
                value={"RESULTS"}
                onClick={(e) => {
                  setSendOption(e.target.value);
                  setChooseLeads([]);
                  setChooseLeadsFlag(false);
                }}
              >
                WYNIKI
              </button>
              <button
                className="loginButtonLogin"
                style={{
                  margin: "0",
                  backgroundColor: "gray",
                  borderColor: "gray",
                  width: "250px",
                }}
                value={"CONF"}
                onClick={(e) => {
                  setSendOption(e.target.value);
                  setChooseLeads([]);
                  setChooseLeadsFlag(false);
                }}
              >
                KLIENCI CONF.
              </button>
            </div>
          </div>
          <div
            style={{
              paddingTop: "2vh",
              paddingBottom: "2vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            {sendOption === "PENDING" ? (
              leadsBody
            ) : sendOption === "CONF" ? (
              <SendClientsConf />
            ) : sendOption === "RESULTS" ? (
              <SendClientsResults />
            ) : sendOption === "FINISHED" ? (
              leadsBodySend
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SendLeads;
